<template>
  <div>
    <input
      type="hidden"
      :data-vv-scope="validationScope"
      :name="'registration-lookup'"
      :value="registrationSelectionKey"
      v-validate.continues="'registration-lookup'"/>

    <ManualEntryConfirmationStateComponent
      v-show="showManualInputSuccessState"
      :showDisabledState="!allowInput"
      @editManualEntryClick="showOverlay()"/>

    <DisabledRegistrationInputComponent
      v-show="!showManualInputSuccessState"
      :showInputTick="isRegistrationLookupDataSet"
      :showErrorState="true"
      :showLabel="showLabel"
      :showDisabledState="!allowInput"
      :isInteractive="true"
      @registrationInputClick="showOverlay()"/>

    <RegistrationOverlayComponent
      :goToNextStep="goToNextStep"
      :validationScope="childValidationScope"
      ref="registrationOverlayComponent"/>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Prop, Ref, Watch, Inject
} from 'vue-property-decorator';
import DisabledRegistrationInputComponent from '@/components/vehicle/lookup/DisabledRegistrationInputComponent.vue';
import RegistrationOverlayComponent from '@/components/vehicle/lookup/RegistrationOverlayComponent.vue';
import ManualEntryConfirmationStateComponent from '@/components/vehicle/lookup/ManualEntryConfirmationStateComponent.vue';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import Valuation from '@/models/valuation/Valuation';
import ValuationVehicle from '../../../models/valuation/ValuationVehicle';

Validator.extend('registration-lookup', {
  getMessage: (field: string) => 'Please enter all required fields',
  validate: (value: string) => validationService.isRegistrationLookupDataSet()
});

@Component({
  components: {
  DisabledRegistrationInputComponent,
  RegistrationOverlayComponent,
  ManualEntryConfirmationStateComponent
  }
  })
export default class RegistrationLookupComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: true })
  public showLabel!: boolean;

  @Prop({ default: true })
  public disableRegistrationInput!: boolean;

  @Prop({ default: true })
  public goToNextStep!: boolean;

  private childValidationScope: string = 'overlayValidationScope';

  @Prop({ default: 'overlayWrapperValidationScope' })
  public validationScope!: string;

  @Ref()
  public readonly registrationOverlayComponent!: RegistrationOverlayComponent;

  public get allowInput(): boolean {
    return !this.disableRegistrationInput || (this.disableRegistrationInput && this.isStepValid);
  }

  public get registrationSelectionKey(): string {
    return this.$store.getters['vehicleValuationModule/registrationSelectionKey'];
  }

  public get isManualVehicle() {
    return this.$store.getters['vehicleValuationModule/isManualVehicle'];
  }

  public get isStepValid() {
    const errors = this.$validator.errors.items.filter((x) => x.scope === this.validationScope && x.field !== 'registration-lookup');

    return errors.length === 0;
  }

  public get showManualInputSuccessState(): boolean {
    return this.isManualVehicle && this.valuationVehicle.plateYear !== null && this.valuationVehicle.name.length > 0;
  }

  public get valuationVehicle(): ValuationVehicle {
    const vehicleValuation: Valuation = this.$store.getters['vehicleValuationModule/vehicleValuation'];
    return vehicleValuation.vehicle;
  }

  private showOverlay() {
    if (this.allowInput) {
      this.registrationOverlayComponent.toggleModal();
    }
  }

  public get isRegistrationLookupDataSet(): boolean {
    return this.$store.getters['vehicleValuationModule/isRegistrationLookupDataSet'];
  }

  @Watch('registrationSelectionKey')
  public validateSelectedOptions() {
    this.$validator.validateAll(this.validationScope);
  }

  public mounted() {
    this.$validator.validateAll(this.validationScope);
  }

  public created() {
    this.$validator.validateAll(this.validationScope);
  }
}
</script>
